var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"x-large":_vm.xLarge,"large":_vm.large,"disabled":_vm.disable || _vm.isOffline,"loading":_vm.loading,"color":(_vm.color + " darken-3"),"block":_vm.block,"outlined":_vm.outlined,"text":_vm.text}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }